import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

const LANGS: { code: string; label: string }[] = [
  { code: "en", label: "EN" },
  { code: "nl", label: "NL" },
];

export function LanguageSwitcher({ className = "", inverted = false }: { className?: string; inverted?: boolean }) {
  const { t, i18n } = useTranslation();
  const current = i18n.resolvedLanguage ?? "en";

  return (
    <div className={`inline-flex items-center gap-1 text-xs ${className}`}>
      <Globe className={`w-3.5 h-3.5 ${inverted ? "text-white/70" : "text-muted"}`} aria-hidden />
      {LANGS.map((lang, i) => (
        <span key={lang.code} className="flex items-center">
          <button
            type="button"
            onClick={() => i18n.changeLanguage(lang.code)}
            className={
              current.startsWith(lang.code)
                ? `tap-target px-1 py-2 font-medium ${inverted ? "text-white" : "text-text"}`
                : `tap-target px-1 py-2 transition-colors ${inverted ? "text-white/60 hover:text-white" : "text-muted hover:text-text"}`
            }
            aria-label={t("common.switch_to_language", { lang: lang.label })}
          >
            {lang.label}
          </button>
          {i < LANGS.length - 1 && <span className={`mx-1 ${inverted ? "text-white/40" : "text-muted"}`}>·</span>}
        </span>
      ))}
    </div>
  );
}
